"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var LOG_ACTION = { "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "mutation", "name": { "kind": "Name", "value": "logEvent" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "input" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "LogEventInput" } } }, "defaultValue": undefined }], "directives": [], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "logEvent" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "input" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "input" } } }], "directives": [], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "errors" }, "arguments": [], "directives": [], "selectionSet": undefined }] } }] } }], "loc": { "start": 0, "end": 100, "source": { "body": "\n  mutation logEvent($input: LogEventInput!) {\n    logEvent(input: $input) {\n      errors\n    }\n  }\n", "name": "GraphQL request", "locationOffset": { "line": 1, "column": 1 } } } };
var LogEvent;
(function (LogEvent) {
    LogEvent["TODO"] = "TODO";
})(LogEvent = exports.LogEvent || (exports.LogEvent = {}));
exports.logEventPayload = function (event, shopifyProductId, shopifyVariantId, shopifyImageId) {
    // Stop logging to ease load on elasticsearch
    /*
    batchClient.mutate<logEvent, logEventVariables>({
      mutation: LOG_ACTION,
      variables: {
        input: {
          event: {
            sessionId: getSessionKey(),
            browserId: getBrowserKey(),
            eventType: event,
            shopifyProductId,
            shopifyVariantId,
            shopifyImageId,
          },
        },
      },
    });
    */
};
exports.loggingMiddleware = function (store) { return function (next) { return function (action) {
    var state = store.getState();
    var shopifyProductId = state.images.shopifyProductId;
    var shopifyVariantId = state.measurements.displayVariantId;
    var currentImage = state.images.images[state.images.featuredImageIndex];
    var shopifyImageId = currentImage && currentImage.shopifyImageId;
    exports.logEventPayload(action.type, shopifyProductId, shopifyVariantId, shopifyImageId);
    var result = next(action);
    return result;
}; }; };
